





























































import { Filters } from '@shared/interfaces/config';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import { SendProductPaymentRequestMessageFormModel } from '@tools/interfaces/template';

@Component({
  name: 'send-product-payment-request-message',
  components: {
    'bpc-entity-select': EntitySelect,
    'bpc-text-editor': TextEditor,
    'bpc-input': Input,
  },
})
export default class SendProductPaymentRequestMessage extends Vue {
  // PROPS
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: Number }) readonly defaultTemplateId: number;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly errors: Record<string, string[]>;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly contactIds: number[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];

  // DATA
  public selectedContactIds = [];

  formModel: SendProductPaymentRequestMessageFormModel = {
    template: null,
    entity_name: null,
    entity_ids: [],
    body: null,
    title: null,
    sending_type: 'personalized',
    type: 'payment_request',
  };
  errorByField = {
    entity_name: null,
    entity_ids: [],
    title: null,
    body: null,
    sending_type: 'personalized',
    type: 'payment_request',
  };

  public labelInputAttributes = {
    for: 'global__',
  };

  // COMPUTED
  get templateSelectorFilters(): Filters {
    return [
      {
        filterField: 'entity',
        value: this.entityName.replaceAll('-', '_'),
      },
      {
        filterField: 'available_in',
        value: 'admin',
      },
      {
        filterField: 'type',
        value: 'email',
      },
      {
        filterField: 'message_type',
        value: this.formModel.type,
      },
    ];
  }

  get selectedTemplateId(): number {
    return this.formModel?.template?.id || null;
  }

  // LIFECYCLE
  created() {
    if (this.defaultTemplateId) {
      this.loadDefaultTemplate();
    }
  }
  mounted() {
    this.selectedContactIds = this.contactIds;
    this.formModel.entity_name = this.entityName;
    this.formModel.entity_ids = this.selectedItemIds;
  }

  // METHODS
  setTitleWithTemplateSelectedContent() {
    this.formModel.title = this.formModel?.template?.name || '';
  }

  setBodyWithTemplateSelectedContent() {
    this.formModel.body = this.formModel?.template?.content || '';
  }

  modelFieldChange(field) {
    this.errorByField[field] = null;
  }

  setErrorByField() {
    this.errorByField = Object.keys(this.errors).reduce((res, key) => {
      res[key] = this.errors[key][0] || null;
      return res;
    }, this.errorByField);
  }

  cleanErrorByField() {
    this.errorByField = {
      entity_name: null,
      entity_ids: null,
      title: null,
      body: null,
      sending_type: null,
      type: null,
    };
  }

  async loadDefaultTemplate() {
    if (this.defaultTemplateId) {
      const url = `${this.$bpcApiRouteHelper.getEntityPath('template')}/${this.defaultTemplateId}`;
      try {
        const res = await this.$bpcApi.get(url, {}).toPromise();
        if (res.data) {
          this.formModel.template = res.data;
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }

  // WATCHERS
  @Watch('selectedTemplateId')
  onSelectedTemplateIdChange(val?: number) {
    if (val) {
      this.setTitleWithTemplateSelectedContent();
      this.setBodyWithTemplateSelectedContent();
    }
  }
  @Watch('errors', { deep: true })
  onErrorsChange() {
    this.cleanErrorByField();
    this.setErrorByField();
  }
}
